<template>
  <div class="container flex flex-column items-center">
    <div class="ove-container flex flex-column items-center" style="margin-top:50px;">
      <h3>{{ articeVO.title }}</h3>
      <h5 style="margin-top: 20px">发布日期：{{ articeVO.writeTime }}</h5>
      <h5>吉首市城市供水总公司</h5>
      <div class="content" v-viewer ref="detail" v-html="articeVO.content"></div>
    </div>
  </div>
</template>

<script>
import { articleDetail, articlezlsDetail } from "@/axios/front";
import qs from "qs";
export default {
  data() {
    return {
      articeVO: {},
      type: null,
    };
  },
  methods: {
    handleGetImg() {
      const _images = this.$refs.detail.querySelectorAll('img') || [];
      let ims = [];
      for(let i = 0; i < _images.length; i ++) {
        ims.push(_images[i].src);
					_images[i].addEventListener('click', function() {
						var nowImgurl = this.src;
						WeixinJSBridge.invoke("imagePreview", {
							"current" : nowImgurl,
							"urls":ims
						});
					})
      }
    },
    handleArticleDetail(id, type) {
      let req 
      if(type == 5) {
          req = articlezlsDetail(id);
      } else {
        req = articleDetail(id)
      }
      req.then(res => {
        if (res.status === 200) {
          this.articeVO = res.data;
        }
      });
    }
  },
  mounted() {
    let query = qs.parse(this.$route.query);
    if (query.id - 0 > 0) {
      this.handleArticleDetail(query.id, query.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .content {
    margin-top: 40px;
    margin-bottom: 20px;
    text-align: left;
    width: 800px;
  }
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/front/article/Article.vue